/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_DeleteInputs */

const en_cmd_delete = /** @type {(inputs: Cmd_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to trash`)
};

const de_cmd_delete = /** @type {(inputs: Cmd_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den Papierkorb`)
};

/**
* | output |
* | --- |
* | "Move to trash" |
*
* @param {Cmd_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_delete = /** @type {((inputs?: Cmd_DeleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_DeleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_delete(inputs)
	return en_cmd_delete(inputs)
});